import { render } from "./TableView.vue?vue&type=template&id=45c7d690"
import script from "./TableView.vue?vue&type=script&lang=ts"
export * from "./TableView.vue?vue&type=script&lang=ts"
script.render = render

export default script